import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AdminPanel from "./StarAdmin/AdminPanel";
import ASNStatus from "./StarAdmin/ASNStatus";

import LoginForm from "./Star/LoginForm";
import Dashboard from "./Star/Dashboard";
import VendorDetails from "./Star/VendorDetails";
import PurchaseOrder from "./Star/PurchaseOrder";
import BookedInvoice from "./Star/BookedInvoice";
import BookedDebitNote from "./Star/BookedDebitNote";
import BookedCreditNote from "./Star/BookedCreditNote";
import PaymentRecived from "./Star/PaymentRecived";
import UplaodInvoice from "./Star/UplaodInvoice";
import CreditDebit from "./Star/CreditDebit";
import Error from "./Star/Error";
import InwBooking from "./Star/InwBooking";
import Reports from "./Star/Reports";

import "bootstrap/dist/css/bootstrap.min.css";
import "daterangepicker/daterangepicker.css";

function RootRedirect() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const mode = (params.get("mode") || "").toLowerCase();

  if (mode === "embedded") {
    return <Navigate to={`/dashboard${location.search}`} replace />;
  }

  if (mode === "admin") {
    return <Navigate to={`/asnstatus${location.search}`} replace />;
  }

  return <Navigate to="/login" replace />;
}
function App() {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} />

      <Routes>
        {/* Root route decides based on query params */}
        <Route path="/" element={<RootRedirect />} />

        {/* Auth */}
        <Route path="/login" element={<LoginForm />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/asnstatus" element={<ASNStatus />} />
        {/* Application Routes */}
        <Route path="/vendordetails" element={<VendorDetails />} />
        <Route path="/purchaseorder" element={<PurchaseOrder />} />
        <Route path="/bookedinvoice" element={<BookedInvoice />} />
        <Route path="/bookeddebitnote" element={<BookedDebitNote />} />
        <Route path="/bookedcreditnote" element={<BookedCreditNote />} />
        <Route path="/paymentrecived" element={<PaymentRecived />} />
        <Route path="/uploadinvoice" element={<UplaodInvoice />} />
        <Route path="/inwbooking" element={<InwBooking />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/creditdebit" element={<CreditDebit />} />

        {/* Error */}
        <Route path="/error" element={<Error />} />

        {/* Catch all */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
